<div class="modal-header">
  <h5 class="modal-title">All Session on Workstation {{data.vmName}}</h5>
</div>

<div  *ngIf="available"  class="modal-body">
  <table class="table table-hover table-condensed"
         cellspacing="0"
         id="sessionInfoList"
         style="border-collapse: collapse; white-space: nowrap;">
    <thead>
      <tr style="height: 22px" class="synchpc-th">
        <th scope="col">
          <a style="color: White; text-decoration: none; cursor: default">#</a>
        </th>
        <th scope="col">
          <a style="color: White; text-decoration: none; cursor: default">
            Session Name
          </a>
        </th>
        <th scope="col">
          <a style="color: White; text-decoration: none; cursor: default">
            State
          </a>
        </th>
        <th scope="col">
          <a style="color: White; text-decoration: none; cursor: default">
            User
          </a>
        </th>
        <th scope="col">
          <a style="color: White; text-decoration: none; cursor: default">Deployment</a>
        </th>
        <th scope="col">
          <a style="color: White; text-decoration: none; cursor: default">Actions</a>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr style="cursor: pointer; height:22px !important"
          [ngClass]="{ highlightClickedRow: tempSessionName == session.name }"
          *ngFor="
                let session of sessions
                let i = index
                ">
        <td style="cursor: pointer" scope="row"> {{ i + 1 }} </td>
        <td style="cursor: pointer" scope="row">
          {{ session.name }}
        </td>
        <td style="cursor: pointer" scope="row"> {{ session.state | slice:3}} </td>
        <td style="cursor: pointer">{{ session.user }} </td>
        <td style="cursor: pointer">{{ session.deployment }}</td>
        <td style="cursor: pointer">
          <span class="bi bi-box-arrow-right"
                style="color: var(--s-primary-color); font-size: large"
                title="Remove on-going sessions"
                (click)="removeSession(session)">
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<p *ngIf="!available" class="text-grey no-session-message ">No Session Available</p>
<div class="modal-footer text-grey">
  <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
</div>



<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="default"
             zIndex="1"
             color="var(--s-primary-color)"
             type="ball-spin"
             [fullScreen]="false"
             name="updateNode"><p class="pleaseWait text-grey">Please wait ...</p></ngx-spinner>
